<div class="page-container post-trade-container container">
  <div class="apps w-100">
    <div class="buttons-container">
      <div class="apps-container">
        @for (app of apps; track app.appName; let idx = $index) {
          @if (rights.includes(app.appRight)) {
            <button
              type="button"
              class="app-button"
              [ngClass]="{ active: activeApp === app.app }"
              (click)="activateApp(app.app)"
            >
              <div class="icon-container">
                <mat-icon>{{ app.icon }}</mat-icon>
              </div>
              <div class="mt-2">
                {{ app['appName'] }}
              </div>
              <span class="right-border"></span>
            </button>
          }
        }
      </div>
    </div>
  </div>

  <div class="app-dashboard-container w-100">
    <div class="actions">
      <button
        type="button"
        class="launch-button"
        [disabled]="findActiveApp(activeApp)?.disabled"
        (click)="nav(findActiveApp(activeApp).route)"
      >
        @if (findActiveApp(activeApp)?.disabled) {
          <mat-icon>engineering</mat-icon> Coming Soon!
        } @else {
          <mat-icon>rocket_launch</mat-icon> Launch
          {{ findActiveApp(activeApp).appName }}
        }
      </button>

      @switch (activeApp) {
        @case ('TR') {
          <app-trade-review-dashboard />
        }
        @case ('AR') {
          <app-account-review-dashboard />
        }
        @case ('RR') {
          <app-rep-review-dashboard />
        }
        @case ('AML') {
          <app-aml-monitor-dashboard />
        }
      }
    </div>
  </div>

  <app-background-decoration />
</div>
